import { render, staticRenderFns } from "./MobileAppShell.vue?vue&type=template&id=933ed8ac&scoped=true"
import script from "./MobileAppShell.vue?vue&type=script&lang=js"
export * from "./MobileAppShell.vue?vue&type=script&lang=js"
import style0 from "./MobileAppShell.vue?vue&type=style&index=0&id=933ed8ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933ed8ac",
  null
  
)

export default component.exports